import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable()
export class IsLoggedInService implements CanActivate {

  constructor(private _auth: AuthService, private _router: Router) {
  }

  canActivate(): boolean {
    if (sessionStorage.getItem('access_token')) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/auth/isLoggedIn.service.ts